import { SocialNetworksContainer } from '../containers/SocialNetworksContainer/index'

export const SocialNetworksPage = () => (
    <SocialNetworksContainer/>
)